export const ACCOUNT_RECOVERY_INTENT_KEY = "unjabbedAccountRecoveryIntentV1";
export const ACCOUNT_RECOVERY_TOKEN_KEY = "unjabbedAccountRecoveryTokenV1";

export const saveAccountRecoveryIntent = () => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(ACCOUNT_RECOVERY_INTENT_KEY, "likes_you");
};

export const hasAccountRecoveryIntent = () =>
  typeof window !== "undefined" &&
  window.localStorage.getItem(ACCOUNT_RECOVERY_INTENT_KEY) === "likes_you";

export const saveAccountRecoveryToken = (token: string) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(ACCOUNT_RECOVERY_TOKEN_KEY, token);
};

export const getAccountRecoveryToken = () =>
  typeof window === "undefined"
    ? ""
    : window.localStorage.getItem(ACCOUNT_RECOVERY_TOKEN_KEY) || "";

export const clearAccountRecoverySession = () => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(ACCOUNT_RECOVERY_INTENT_KEY);
  window.localStorage.removeItem(ACCOUNT_RECOVERY_TOKEN_KEY);
};

export const getPostLoginPath = (
  result: { kind?: string } | undefined,
  fallback: string,
) =>
  result?.kind === "recovery" || hasAccountRecoveryIntent()
    ? "/recover-profile"
    : fallback;
